module.exports = __webpack_public_path__ + "static/media/transfer.fdefae7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/transfer.png
// module id = 1106
// module chunks = 0